
import React, { useState } from "react";
import team from "./career-hero.jpg";
import "./Careers.css";
import { Helmet } from "react-helmet-async";
import JobsAccordion from "./jobList";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import emailjs from "emailjs-com";
import Banner from "../../Banner/Banner";
import { jobsData } from "./jobsData";
import Select from "react-select";
import axios from "axios";

function Careers() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    jobs: "",
    resume: null
  });

  const options = jobsData.map(job => ({
    value: job.value,
    label: job.name
  }));

  const [selectedJob, setSelectedJob] = useState(null);

  const [loading, setLoading] = useState(false);


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (file.size > 2000000) {
      toast.error("File size must be under 2MB");
      e.target.value = null;
      return;
    }

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ];

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only PDF, DOC, and DOCX files are allowed");
      e.target.value = null;
      return;
    }

    setFormData({
      ...formData,
      resume: file
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!formData.resume) {
      toast.error("Please upload a resume");
      setLoading(false);
      return;
    }

    try {

      const data = new FormData();
      data.append("file", formData.resume);
      data.append("upload_preset", process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
      data.append(
        "public_id",
        `${formData.name}_${formData.jobs}`.replace(/[^a-zA-Z0-9]/g, "_").trim()
      );

      const cloudinaryRes = await axios.post(
        `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/auto/upload`,
        data
      );

      const resumeUrl = cloudinaryRes.data.secure_url;

      const emailParams = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        jobs: formData.jobs,
        resume_link: resumeUrl
      };

      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_RESUME_UPLOAD_TEMPLATE_ID,
        emailParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      toast.success("Resume sent successfully!");
      setLoading(false);

      setFormData({
        name: "",
        email: "",
        phone: "",
        jobs: "",
        resume: null
      });

      setSelectedJob(null)

      e.target.reset();

    } catch (error) {
      toast.error("Something went wrong");
      setLoading(false);

      setFormData({
        name: "",
        email: "",
        phone: "",
        jobs: "",
        resume: null
      });

      setSelectedJob(null);

      console.error("Status:", error.response?.status);
      console.error("Data:", error.response?.data);
    }
  };

  const removeFile = () => {
    setFormData({
      ...formData,
      resume: null
    });

    const fileInput = document.getElementById("resumeInput");
    if (fileInput) fileInput.value = "";
  };

  return (
    <>
      <Helmet>
        <title>
          Join KitKat Tech – Career Opportunities and Growth
        </title>
        <meta
          name="description"
          content="Explore careers at KitKat Tech, offering top web development training with certification and software training courses in Coimbatore to boost your professional growth."
        />
        <meta
          name="keywords"
          content="Certification course, IT courses, Programming course, Developer course, Tech careers, Placement training, Software training, Web training"
        />

        {/* <!-- Canonical URL --> */}
        <link rel="canonical" href="https://kitkatsoftwaretechnologies.com/careers" />

        {/* <!-- Hreflang Tags --> */}
        <link rel="alternate" hrefLang="en-US" href="https://kitkatsoftwaretechnologies.com/careers" />
        <link rel="alternate" hrefLang="en-GB" href="https://kitkatsoftwaretechnologies.com/careers" />
        <link rel="alternate" hrefLang="en-MY" href="https://kitkatsoftwaretechnologies.com/careers" />
        <link rel="alternate" hrefLang="en-SG" href="https://kitkatsoftwaretechnologies.com/careers" />
        <link rel="alternate" hrefLang="en-AE" href="https://kitkatsoftwaretechnologies.com/careers" />
        <link rel="alternate" hrefLang="x-default" href="https://kitkatsoftwaretechnologies.com/careers" />

      </Helmet>

      <div className="careers-container">
        {/* Hero Section */}
        <Banner image={team} alt="Join our team" />

        <div className="join-team">
          <h1 className="contents">Join KitKat Software Technologies – Careers & Job Openings</h1>
          <p className="p-content">
            If you are looking to work on challenging projects with leading Fortune 500 companies and want to advance your professional career, you are in the right place.
          </p>
        </div>

        {/* Why Work With Us? */}
        <section className="careers-info">
          <h2 className="contents">Why Work With Us?</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <span>💻</span>
              <h3>Impactful Projects</h3>
              <p className="p-content">
                Work on practical projects that create real impact.
              </p>
            </div>
            <div className="benefit-card">
              <span>🤝</span>
              <h3>Collaborative Culture</h3>
              <p className="p-content">
                Be part of a friendly and innovative team.
              </p>
            </div>
            <div className="benefit-card">
              <span>🚀</span>
              <h3>Career Growth</h3>
              <p className="p-content">
                Learn, grow, and unlock new opportunities.
              </p>
            </div>
          </div>
        </section>


        {/* Internship Section */}
        <section className="internship-section">
          <h2 className="contents">Paid Internship Opportunities for Students & Graduates</h2>
          <p className="p-content">
            For over 10 years, KitKat Software Technologies has offered certified internship
            programs for students and professionals who want to build or switch their careers in
            the IT industry. Our internships provide hands-on training, real-time project experience,
            and expert mentorship to develop practical, job-ready skills.
          </p>
          <p className="p-content">
            We offer paid internship opportunities for 2007–2026 batches, including college
            students, graduates, postgraduates, and career switchers. Our programs are designed to
            enhance technical knowledge, boost confidence, and improve employability.
          </p>
          <p className="p-content">
            Join KitKat Software Technologies to gain industry exposure, earn recognized
            certification, and take the next step toward a successful IT career. Contact us today to
            learn more.
          </p>
        </section>

        {/* Job Listings */}
        {/* <section className="job-listings">

          <JobsAccordion onSelectJob={(job) => {
            setFormData(prev => ({ ...prev, jobs: job.value }));
          }} />

        </section> */}

        {/* Resume Upload Form */}
        {/* <section className="resume-upload">
          <h2 className="contents">Upload Your Resume</h2>
          <form className="resume-form" onSubmit={handleSubmit}>
            <input type="text" name="name" placeholder="Enter your name"
              onChange={handleChange} required />
            <input type="email" name="email" placeholder="Enter your email"
              onChange={handleChange} required />

            <input type="tel" name="phone" placeholder="Enter your mobile number"
              maxLength="10"
              onChange={handleChange}
              required />

         
            <Select
              options={options}
              value={selectedJob}
              isSearchable={false}
              placeholder="Job Applied"
              className="select-dd"
              onChange={(selectedOption) => {

                setSelectedJob(selectedOption);

                setFormData(prev => ({
                  ...prev,
                  jobs: selectedOption.value
                }));
              }

              }
              styles={{
                container: (base) => ({
                  ...base,
                  width: "100%",

                }),
                control: (base) => ({
                  ...base,
                  minHeight: "50px",
                  borderRadius: "8px",
                  textAlign: 'left',
                  fontSize: '1rem'
                }),
                menu: (base) => ({
                  ...base,
                  width: "100%",
                }),
                option: (base, state) => ({
                  ...base,
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  textAlign: "left",
                  backgroundColor: state.isSelected
                    ? "#f0f0f0"      // selected option color
                    : state.isFocused
                      ? "#f5f5f5"      // hover color
                      : "white",
                  color: "black",
                }),
              }}
            />


            <input type="file" id="resumeInput" accept=".pdf,.doc,.docx" onChange={handleFileChange} required />
            {formData.resume && (
              <div className="file-preview">
                <span>{formData.resume.name}</span>
                <div type="button" onClick={removeFile} className="file-remove">
                  ✖
                </div>
              </div>
            )}

            <button type="submit" disabled={loading}>
              {loading ? 'Uploading...' : 'Upload & Send'}
            </button>
          </form>
        </section> */}
      </div>
      {/* <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
      /> */}
    </>
  );
}

export default Careers;
